import React from 'react';

export function Skeleton({ lines = 4 }) {
  const widths = [100, 72, 88, 60, 80, 90, 65, 75];
  return (
    <div className="ui-skeleton" aria-busy="true" aria-label="Loading">
      {Array.from({ length: lines }, (_, i) => (
        <div
          key={i}
          className="ui-skeleton-line"
          style={{ width: `${widths[i % widths.length]}%` }}
        />
      ))}
    </div>
  );
}
